/*
 *  This document is the CONFIDENTIAL PROPERTY of Corero Network Security, Inc.
 *  Copyright (C) 2017-2024 by Corero Network Security, Inc. All rights reserved.
 *  Notice of copyright on this document does not constitute publication.
 */

import React, {Component} from 'react';
import {store} from '@corero/ssp-ui-components/stores/EventEmmiterStore';
import ProgressBar from 'react-progress-bar-plus';
import 'react-progress-bar-plus/lib/progress-bar.css';
import Loader from 'corero-ssp-ui/src/components/loader/Loader';

export default class ProgressBars extends Component {

    state = {
        percent: 0,
        isLoading: false
    }

    componentDidMount() {
        store.addProgressBarListener(this._onChange);
    }

    componentWillUnmount = () => {
        store.removeProgressBarListener(this._onChange);
    }

    _onChange = (params) => {
        let debounce = _.debounce(()=>{this.setState({...this.state, ...params})},1000);
        if(!params.isLoading){
            debounce();
        }else{
            this.setState({...this.state, ...params});
                debounce.cancel();
        }
    };

    render() {
        const {percent, isLoading} = this.state;
        if(isLoading) {
            return <div>
                    <ProgressBar percent={percent} autoIncrement={true} spinner={false} intervalTime={Math.random() * 1000} />
                    <Loader display={isLoading}/>
                </div>
        }
        return <div/>;
    }
}
